import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Product } from 'src/app/types/types';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.css']

})
export class ProductCardComponent implements OnInit {

  @Input() product:Product;

  constructor(
    private router :Router,
  ) {
   }

  ngOnInit(): void {
  }

  pushToShowProduct(id:number) {
    this.router.navigate(["product",id]).then( e => {
      if(this.router.url.includes("/product/")){ 
        window.location.reload();
      }
    });
    document.getElementById('navbar').scrollIntoView();
  }

  isNew(product : Product) {
    let today = new Date();
    let aWeekAgo = new Date(today);
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    if (product.date >= aWeekAgo) console.log(product.name + " is NEW!")
    return new Date(product.date) >= aWeekAgo;
  }

  get getPrice() {
    return this.product.price - this.product.price * (this.product.discount / 100)
  }
}
